import Config from 'Config';
import { createSignedRequest } from './createSignedRequest';

export const createSignedGetRequest = async ({
  apiPath,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const url = isLocalApiRequest
    ? `http://localhost:3001/${apiPath}`
    : `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`;

  const { activeEmployerId, activeEmployerBusinessId } = activeEmployerInfo;

  const request = {
    url: url,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      ...(activeEmployerId && { 'X-Active-Employer-Id': activeEmployerId }),
      ...(activeEmployerBusinessId && {
        'X-Active-Employer-Business-Id': activeEmployerBusinessId,
      }),
    },
  };
  const signedRequest = await createSignedRequest(request);

  return signedRequest;
};

export const createSignedPostRequest = async ({
  apiPath,
  body,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const url = isLocalApiRequest
    ? `http://localhost:3001/${apiPath}`
    : `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`;

  const { activeEmployerId, activeEmployerBusinessId } = activeEmployerInfo;

  const request = {
    url: url,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
      ...(activeEmployerId && { 'X-Active-Employer-Id': activeEmployerId }),
      ...(activeEmployerBusinessId && {
        'X-Active-Employer-Business-Id': activeEmployerBusinessId,
      }),
    },
    body: JSON.stringify(body), // aws4 looks for body; axios for data
    data: body,
  };
  const signedRequest = await createSignedRequest(request);

  return signedRequest;
};

export const createSignedPatchRequest = async ({
  apiPath,
  body,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const url = isLocalApiRequest
    ? `http://localhost:3001/${apiPath}`
    : `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`;

  const { activeEmployerId, activeEmployerBusinessId } = activeEmployerInfo;

  const request = {
    url: url,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PATCH',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
      ...(activeEmployerId && { 'X-Active-Employer-Id': activeEmployerId }),
      ...(activeEmployerBusinessId && {
        'X-Active-Employer-Business-Id': activeEmployerBusinessId,
      }),
    },
    body: JSON.stringify(body), // aws4 looks for body; axios for data
    data: body,
  };
  const signedRequest = await createSignedRequest(request);

  return signedRequest;
};

export const createSignedDeleteRequest = async ({
  apiPath,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const url = isLocalApiRequest
    ? `http://localhost:3001/${apiPath}`
    : `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`;

  const { activeEmployerId, activeEmployerBusinessId } = activeEmployerInfo;

  const request = {
    url: url,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'DELETE',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
      ...(activeEmployerId && { 'X-Active-Employer-Id': activeEmployerId }),
      ...(activeEmployerBusinessId && {
        'X-Active-Employer-Business-Id': activeEmployerBusinessId,
      }),
    },
  };
  const signedRequest = await createSignedRequest(request);

  return signedRequest;
};
